import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { Link } from './Link';
import { Telegram } from './icons/Telegram';
import { MiniCard, CardGroup } from './MiniCard';

export function BosSupportFragment() {
    return (
        <Fragment>
            <FormattedMessage
                tagName="p"
                defaultMessage="Have questions? Our dev and support teams are always available to help.{br}Join our Telegram group"
                values={{ br: <br /> }}
            />

            <CardGroup style={{ margin: '1rem 0' }}>
                <MiniCard title="EN group" href="https://t.me/BraiinsOS" actionIcon={<Telegram />} />

                <MiniCard title="ES group" href="https://t.me/BraiinsOS_ES" actionIcon={<Telegram />} />

                <MiniCard title="RU group" href="https://t.me/BraiinsOS_RU" actionIcon={<Telegram />} />

                <MiniCard title="ZH group" href="https://t.me/BraiinsOS_ZH" actionIcon={<Telegram />} />
            </CardGroup>

            <FormattedMessage
                tagName="p"
                defaultMessage="You can also <a>send VIP request</a> to our support team."
                values={{
                    a: ch => (
                        <Link target="_blank" href="https://help.braiins.com/en/support/tickets/new" children={ch} />
                    ),
                }}
            />
        </Fragment>
    );
}
